const BACKEND_ALIASES = {
  vocodeAlpha: {
    host: "https://fictive-v3.engine.fictivereality.com",
    channel: "alpha",
    family: "vocode",
  },
  vocodeBeta: {
    host: "https://fictive-v3.engine.fictivereality.com",
    channel: "beta",
    family: "vocode",
  },
  vocodeAlphaBackup: {
    host: "https://fictive-v3-backup.engine.fictivereality.com",
    channel: "alpha",
    family: "vocode",
  },
  vocodeBetaBackup: {
    host: "https://fictive-v3-backup.engine.fictivereality.com",
    channel: "beta",
    family: "vocode",
  },
  pipecatDev: {
    host: "https://dev.ai.fictivereality.com",
    channel: "main",
    family: "pipecat",
  },
  pipecatDevAlpha: {
    host: "https://dev.ai.fictivereality.com",
    channel: "alpha",
    family: "pipecat",
  },
  pipecatAlpha: {
    host: "https://prod.ai.fictivereality.com",
    channel: "alpha",
    family: "pipecat",
  },
  pipecatBeta: {
    host: "https://prod.ai.fictivereality.com",
    channel: "beta",
    family: "pipecat",
  },
  pipecatStable: {
    host: "https://prod.ai.fictivereality.com",
    channel: "stable",
    family: "pipecat",
  },
};

export const resolveDefaultBackendAlias = defaultBackendChannel => {
  const alias = defaultBackendChannel || null;
  if (!alias || alias === "default" || !BACKEND_ALIASES[alias]) {
    throw new Error(`Unknown default backend alias: ${defaultBackendChannel || "unset"}`);
  }

  return {
    type: "alias",
    alias,
  };
};

export const applyBackupAlias = alias => {
  if (alias === "vocodeAlpha") return "vocodeAlphaBackup";
  if (alias === "vocodeBeta") return "vocodeBetaBackup";
  return alias;
};

export const buildAliasBaseUrl = ({ host, family, channel }) => {
  if (family === "pipecat") {
    return `${host}/convai-${channel}`;
  }
  return `${host}/convai_vocode_${channel}`;
};

export const resolveBackendBaseUrl = ({
  defaultBackendChannel,
  requestedBackendChannel,
  customServerUrl,
  backup = false,
  localBackendUrl = null,
} = {}) => {
  let resolvedAlias = requestedBackendChannel || null;
  let resolvedBaseUrl;
  let resolutionReason = "resolved from backendChannel";

  if (localBackendUrl) {
    resolvedAlias = "localhost";
    resolutionReason = "VITE_LOCAL_BACKEND_URL is set";
    resolvedBaseUrl = localBackendUrl;
  } else if (resolvedAlias === "custom" && customServerUrl) {
    resolvedAlias = "custom";
    resolutionReason = "backendChannel is custom and customServerUrl is set";
    resolvedBaseUrl = customServerUrl;
  } else {
    let aliasResolution;

    if (resolvedAlias && resolvedAlias !== "default" && BACKEND_ALIASES[resolvedAlias]) {
      resolutionReason = "resolved from backendChannel";
      aliasResolution = {
        type: "alias",
        alias: resolvedAlias,
      };
    } else {
      resolutionReason = "resolved from deployment default";
      aliasResolution = resolveDefaultBackendAlias(defaultBackendChannel);
    }

    if (aliasResolution.type === "fixed") {
      resolvedAlias = "defaultFixed";
      resolvedBaseUrl = aliasResolution.baseUrl;
    } else {
      const alias = backup ? applyBackupAlias(aliasResolution.alias) : aliasResolution.alias;
      const target = BACKEND_ALIASES[alias];
      if (!target) {
        throw new Error(`Unknown backend alias: ${alias}`);
      }
      resolvedAlias = alias;
      if (backup && alias !== aliasResolution.alias) {
        resolutionReason += " with backup override";
      }
      resolvedBaseUrl = buildAliasBaseUrl(target);
    }
  }

  return {
    alias: resolvedAlias,
    baseUrl: resolvedBaseUrl,
    reason: resolutionReason,
  };
};
